import { render, staticRenderFns } from "./staticTime.vue?vue&type=template&id=5f6adea3"
import script from "./staticTime.vue?vue&type=script&lang=js"
export * from "./staticTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports